// clickable 행/카드/그리드 아이템이 이벤트를 자기 입력으로 처리해도 되는지 판정한다.
// 컨테이너는 `isContainerInputTarget` 하나로 묻는다: 자기 DOM 안에서 났고, 중첩 인터랙티브
// 요소(버튼·링크·입력 등) 위가 아닌 이벤트만 컨테이너 입력이다.
// DataTable/DataGridView 행 활성화(useRowActivation)·행 selection과 Card 선택적 클릭이 공유한다.
/**
 * c6 인터랙티브 primitive가 **보이는 클릭 대상**에 다는 마커. 네이티브 태그도 ARIA role도
 * 아닌 커스텀 시각 요소(Checkbox의 네모 span 등)는 아래 태그/role 목록으로는 잡히지 않아,
 * 컨테이너 클릭에 흡수돼 "체크 + 행 활성화"가 동시에 일어난다. 그런 요소에 이 속성을 단다.
 */
export const NESTED_INTERACTIVE_ATTR = "data-c6-interactive";

export const NESTED_INTERACTIVE_SELECTOR = [
  "a",
  "button",
  "input",
  "select",
  "textarea",
  "label",
  "[role='button']",
  "[role='link']",
  "[role='checkbox']",
  "[role='switch']",
  "[role='radio']",
  "[role='tab']",
  "[role='option']",
  "[role='menuitem']",
  "[role='menuitemcheckbox']",
  "[role='menuitemradio']",
  "[role='slider']",
  "[role='spinbutton']",
  "[contenteditable='true']",
  `[${NESTED_INTERACTIVE_ATTR}]`,
].join(", ");

export function isNestedInteractiveTarget(
  target: EventTarget | null,
  currentTarget: Element,
): boolean {
  if (!(target instanceof Element)) {
    return false;
  }

  const interactiveTarget = target.closest(NESTED_INTERACTIVE_SELECTOR);
  return interactiveTarget != null && interactiveTarget !== currentTarget;
}

/**
 * 컨테이너가 자기 입력(활성화·selection·키보드 탐색)으로 처리할 이벤트인지 판정한다.
 *
 * 컨테이너의 React 자손이 포털로 띄운 레이어(popup·modal)는 DOM에서 컨테이너 밖에 놓이지만 그
 * 이벤트는 React 트리를 따라 컨테이너 핸들러까지 버블한다. 그 레이어의 입력은 컨테이너의 입력이
 * 아니므로 DOM 포함 관계로 거른다.
 */
export function isContainerInputTarget(
  target: EventTarget | null,
  currentTarget: Element,
): boolean {
  return (
    target instanceof Node &&
    currentTarget.contains(target) &&
    !isNestedInteractiveTarget(target, currentTarget)
  );
}
